// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bdb3ff076125fad8e3a3","655":"403f01c901e3336d85fd"}[chunkId] + ".js";
};